/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BatchUpdateLlgPolicyItem } from '../models/BatchUpdateLlgPolicyItem';

export class BatchUpdateLlgPoliciesRequest {
  'updates': Array<BatchUpdateLlgPolicyItem>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "updates",
      "baseName": "updates",
      "type": "Array<BatchUpdateLlgPolicyItem>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BatchUpdateLlgPoliciesRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

